import { render, staticRenderFns } from "./configure.vue?vue&type=template&id=60998dbc&scoped=true"
import script from "./configure.vue?vue&type=script&lang=js"
export * from "./configure.vue?vue&type=script&lang=js"
import style0 from "./configure.vue?vue&type=style&index=0&id=60998dbc&prod&scoped=true&lang=css"
import style1 from "./configure.vue?vue&type=style&index=1&id=60998dbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60998dbc",
  null
  
)

export default component.exports